import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

// Screen state
export interface ScreenState {
  allowedScreens: string[];
}

// Initial state
const initialState: ScreenState = {
  allowedScreens: [],
};

// Slice
const screenSlice = createSlice({
  name: 'screen',
  initialState,
  reducers: {
    setAllowedScreens(state, action: PayloadAction<string[]>) {
      state.allowedScreens = action.payload;
    },
  },
});

// Actions
export const screenActions = screenSlice.actions;

// Selectors
export const selectAllowedScreens = (state: RootState) => state.screen.allowedScreens;

// Reducer
export const screenReducer = screenSlice.reducer;
